export default __webpack_public_path__ + "static/media/BeramoniumMissions.68e52704.png";